import { render, staticRenderFns } from "./UsulanPerubahanViewEmail.vue?vue&type=template&id=39e9a73b&scoped=true&lang=pug&"
import script from "./UsulanPerubahanViewEmail.vue?vue&type=script&lang=js&"
export * from "./UsulanPerubahanViewEmail.vue?vue&type=script&lang=js&"
import style0 from "./UsulanPerubahanViewEmail.vue?vue&type=style&index=0&id=39e9a73b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e9a73b",
  null
  
)

export default component.exports